import { AuthSuiteSdkSetup, AuthSuiteRequest } from '@cbsi-cbscom/auth-suite-sdk';

export default class AuthSuiteSdkSetupService {
    constructor() {
        this.sdkSetupService = new AuthSuiteSdkSetup();
    }

    /**
     * Sets clientId and countryCode data needed to perform all SDK requests
     * to shared storage. This function has to be called before performing first request
     * using AuthSuite SDK
     *
     * @param {AuthSuiteRequest} authSuiteRequestData - request param
     * @returns {undefined} - void
     */
    setupAuthSuiteRequestData = (authSuiteRequestData) => {
        this.sdkSetupService.setAuthSuiteRequestData(authSuiteRequestData);
    };
}
